import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import { shallowEqual, useSelector } from 'react-redux';

function CountrySelector({ className, value, onChange, defaultValue, placeholder, disabled, size }) {
  const { payload, isLoading } = useSelector(state => state.accounts.aux, shallowEqual);

  return (
    <Select defaultValue={defaultValue}
            placeholder={placeholder}
            className={className}
            loading={isLoading}
            size={size}
            value={value}
            onChange={onChange}
            style={{ width: '100%' }}
            disabled={disabled}
    >
      {["EU", "US", "GB"].map(value => (<Select.Option value={value}>{value}</Select.Option>))}
    </Select>
  );
}

CountrySelector.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  defaultValue: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.oneOf([PropTypes.bool, PropTypes.any]),
};

export default CountrySelector;
